
<template>
    <div class="body">
        <div class="search-box">
            <div class="input-box">
                <span class="title">年 级：</span>
                <el-date-picker
                        style="width: 240px"
                        v-model="grade"
                        type="year"
                        value-format="yyyy"
                        placeholder="请选择年级"
                        @change="getData()">
                </el-date-picker>
            </div>
            <div class="input-box" style="margin-left: 16px">
                <span class="title">专 业：</span>
                <el-select v-model="majorId" filterable clearable placeholder="请选择专业" @change="getData()" style="width: 240px">
                    <el-option
                            v-for="item in majorList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class='margin-left-30'>
                <el-button class="primary-btn" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="getData()">查询</el-button>
            </div>
        </div>

        <div class="container">
            <el-table
                :data="tableData"
                class="table"
                border
                :cell-style="{color:'#666666',fontSize:'14px'}"
                :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}">

                <el-table-column prop="grade" label="年级" align='center'></el-table-column>

                <el-table-column prop="name" label="专业" align='center'></el-table-column>

                <el-table-column prop="person_num" label="人数" align='center'></el-table-column>

                <el-table-column prop="org" align='center' label="所属院校" v-if="accountOrg == 1">
                    <template slot-scope="scope">
                        {{orgHash[scope.row.org]}}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="280px" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button

                                class="primary-btn"
                                @click="edit(scope.row)"
                        >报告须知</el-button>
                            <el-button
                                    @click="toStudentThesis(scope.row)"
                                    type="primary"
                                    style="margin-left: 16px"
                            >报告审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page=pageIndex
                        :page-size=10
                        :total=pageTotal
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
                title="论文安排"
                :visible.sync="dialogVisible"
                width="900px"
                :before-close="dialogClose">
            <el-form ref="form" :model="form" label-width="90px" :disabled="accountOrg != form.org">
                <el-form-item class="form-item" label="年级：" prop="grade">
                    <el-input class='page-input' placeholder="请输入年级" disabled v-model="form.grade" style="width: 652px"></el-input>
                </el-form-item>
                <el-form-item class="form-item" label="专业：" prop="grade">
                    <el-input class='page-input' placeholder="请输入专业" disabled v-model="form.majorName"  style="width: 652px"></el-input>
                </el-form-item>
                <el-form-item class="form-item" label="论文选题：" prop="grade" style="margin-top: 24px">
                    <div class="btn-box" v-for="(item,index) in form.topics_list">
                        <el-input class="teacher" style="width: 220px" v-model="item.instru_name" placeholder="指导老师"></el-input>
                        <el-input class="topic" v-model="item.topic_name" placeholder="论文题目"></el-input>
                        <el-input class="direction" style="width: 300px" v-model="item.direction" placeholder="论文方向"></el-input>
                        <el-button type="danger" style="margin-left: 16px;" @click="delInput(index)">删除</el-button>
                    </div>
                    <el-button style="width: 652px" @click="addInput()">添加一行</el-button>
                </el-form-item>


                <el-form-item class="form-item" label="选题时间：" style="margin-top: 32px">
                    <el-date-picker
                            style="width: 652px"
                            v-model="form.topics_time"
                            type="datetimerange"
                            range-separator="至"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-item" label="上传时间：">
                    <el-date-picker
                            style="width: 652px"
                            v-model="form.import_time"
                            type="datetimerange"
                            range-separator="至"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item class="form-item" label="论文须知：" prop="statement" style="margin-top: 24px">
                    <el-input type="textarea" style="width: 652px" v-model="form.statement"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">取 消</el-button>
                <el-button :disabled="accountOrg != form.org" type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import { isBlank } from '../../utils/util'

    export default {
        name: 'Thesis',
        data() {
            return {
                value1:'',
                accountOrg:0,
                pageIndex: 1,
                pageSize: 10,
                pageTotal:0,
                tableData: [],
                dialogVisible:false,
                grade:'',
                majorId:'',
                majorName:'',
                majorList:[],
                majorHash:[],
                orgList:[],
                orgHash:[],
                form: {},
                topicsTime:'',
                importTime:''
            };
        },
        created() {
            this.accountOrg = localStorage.getItem("org");
            this.getTblInfo()
            this.getData();
			this.getMajor()
        },
        methods: {
            toStudentThesis(data){
                this.$router.push({path:'/studentThesis',query:{
                    majorName:data.grade+" "+data.name,
                    major_id:data.major_id,
                    grade:data.grade,
                    org:data.org
                }})
            },
            save(){
                let noPass = false
                let parameter = this.form
                if(isBlank(parameter.topics_time)){
                    this.$message.error('请选择选题时间！')
                    return false
                }
                if(isBlank(parameter.import_time)){
                    this.$message.error('请选择上传时间！')
                    return false
                }
                if(isBlank(parameter.statement)){
                    this.$message.error('请输入论文须知！')
                    return false
                }

                parameter.topics_list.forEach((item,index)=>{
                    if(isBlank(item.instru_name) || isBlank(item.topic_name) || isBlank(item.direction)){
                        this.$message.error(`请输入第 ${index+1}行 选题信息！`)
                        noPass = true
                        return false
                    }
                })

                if(noPass){
                    return false
                }


                this.$post(this.BASEURL+`/thesis/arrangement`,parameter).then((res)=>{
                    if(res.code === 200){
                        this.$message.success('编辑成功！')
                        this.dialogVisible = false
                    }else{
                        console.log(res.error);
                    }
                });
            },
            edit(data){
                this.$get(this.BASEURL+`/thesis/arrangement?major_id=${data.major_id}`).then((res)=>{
                    if(res.code === 200){
                        if(res.data.length == 0){
                            this.form = {
                                major_id:data.major_id,
                                grade:data.grade,
                                majorName:data.name,
                                org:data.org,
                                topics_time:[],
                                import_time:[],
                                key_list:[],
                                topics_list:[
                                    {
                                        id:-1,
                                        instru_name:'',
                                        topic_name:'',
                                        direction:''
                                    }
                                ],
                                statement:''
                            }
                        }else{
                            this.form = res.data
                            this.form.org = data.org
                            this.form.grade = data.grade
                            this.form.major_id = data.major_id
                            this.form.majorName = data.name
                            this.form.key_list = []
                        }
                    }else{
                        console.log(res.error);
                    }
                });
                this.dialogVisible = true
            },
            addInput(){
                this.form.topics_list.push({
                    id:-1,
                    instru_name:'',
                    topic_name:'',
                    direction:''
                })
            },
            delInput(index){
                if (this.form.topics_list[index].id > 0){
                    this.form.key_list.push(this.form.topics_list[index].id)
                }
                // if(this.form.topics_list.length == 1){
                //     this.$message.error('已是最后一道选题! 不可删除！')
                //     return false
                // }
                this.form.topics_list.splice(index,1)
            },
            reset(){
                this.majorId = ''
                this.grade = ''
                this.getData()
            },
            getData(){
                this.$get(this.BASEURL+`/thesis/management?page=${this.pageIndex}&major_id=${this.majorId}&grade=${this.grade}`).then((res)=>{
                    if(res.code === 200){
                        this.tableData = res.data
                        this.pageTotal = res.total
                    }else{
                        console.log(res.error);
                    }
                });
            },

            handlePageChange(val) {
                this.pageIndex = val
                this.getData();
            },
			getMajor(){
				this.$get(this.BASEURL+`/thesis/major/Get`).then((res)=>{
				    if(res.code === 200){
                        this.majorList = res.data
				    }else{
				        console.log(res.error);
				    }
				});
			},
            //获取专业列表
            getTblInfo(){
                this.$post(this.BASEURL+'/assets/table/info',{
                    tbl_list:[['id','grade,name','major_base_t'],['org','org_name','academy_base_t']],
                    state:1
                }).then((res)=>{
                    if(res.code === 200){
                        this.orgList = res.data[1][0]
                        this.orgHash = res.data[1][1]
                    }else{
                        console.log(res.error);
                    }
                })
            },
            dialogClose(){
                this.dialogVisible = false
            },
        }
    };
</script>

<style lang="scss" scoped>
    .body{
        button{
            padding: 8px 15px;
            font-size: 14px;
        }
    }
    .search-box{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        padding: 28px 30px;
        margin-top: $distance;
        margin-bottom: $distance;
        border-radius: $radius;
        .search-input{
            width: 240px;
        }
        .title{
            font-size:$title-size;
            line-height:15px;
            color: #343434;
        }
    }
    .btn-box{
        display: flex;
        margin-bottom: 16px;
    }
    .primary-btn{
        border-color: #409EFF;
        color: #409EFF;
    }
    /deep/.teacher .el-input__inner{
        border-radius: 5px 0 0 5px;
    }
    /deep/.topic .el-input__inner{
        border-radius: 0;
        margin-left: -1px;
    }
    /deep/.direction .el-input__inner{
        margin-left: -2px;
        border-radius: 0 5px 5px 0;
    }



</style>
